<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <div
        v-if="menu == 1"
        class="content content-type"
        v-loading.fullscreen.lock="loading"
      >
        <!--        <div class="main-title pd">菜单</div>-->
        <div class="template-main pd">
          <div class="template-left" v-if="list.length > 0">
            <div
              class="t_item"
              v-for="(item, index) in list"
              :key="index"
              @click="toList(item)"
            >
              <div
                class="template-item"
                :style="{
                  background:
                    'linear-gradient(90deg,' +
                    item.color_1 +
                    ',' +
                    item.color_2 +
                    ')',
                }"
              >
                <div class="title">{{ item.name }}</div>
                <div class="prompt_text">{{ item.prompt }}</div>
                <div
                  style="
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div></div>
                  <div class="go_in">
                    前往 <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="menu == 2"
        class="content content-type"
        v-loading.fullscreen.lock="loading"
      >
        <div class="main-title pd">申报</div>
        <div class="line_"></div>
        <div class="template-main pd">
          <div class="template-left" v-if="list2.length > 0">
            <div
              class="t_item"
              v-for="(item, index) in list2"
              :key="index"
              @click="toPath(item)"
            >
              <div class="session_template-item">
                <div class="session_title">{{ item.name }}</div>
                <div class="prompt_text">{{ item.prompt }}</div>
                <div
                  style="
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div></div>
                  <div class="session_go_in">
                    前往 <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="menu == 3"
        class="content content-type"
        v-loading.fullscreen.lock="loading"
      >
        <div class="main-title pd">下载中心</div>
        <div class="line_"></div>
        <div class="template-main pd">
          <div class="template-left" v-if="list3.length > 0">
            <div
              style="margin-bottom: 20px"
              v-for="(item, index) in list3"
              :key="index"
            >
              <el-table
                :data="item.items"
                :cell-style="{ textAlign: 'left' }"
                :header-cell-style="{
                  background: '#EDF1F7',
                  color: '#333',
                  textAlign: 'left',
                }"
              >
                <el-table-column
                  prop="name"
                  :label="item.c_name"
                  width="500"
                ></el-table-column>
                <el-table-column fixed="right" label="操作" width="180">
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="down(scope.row)"
                      type="text"
                    >
                      下载
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getmyMenu,
  declareItems_lists,
  files_lists,
  getOtherActivityDeclarationResult,
  getPaperCertificateList,
} from "@/api/api";
import top from "../components/top.vue"; //头部
export default {
  components: { top },
  name: "home",
  data() {
    return {
      loading: false,
      menu: 1,
      list: [],
      list2: [],
      list3: [],
    };
  },
  created() {
    if (this.$route.params.menu == 2) {
      this.menu = this.$route.params.menu;
    }
  },
  mounted() {
    this.init();
  },
  watch: {},
  methods: {
    // 获取菜单以及内容数据
    async init() {
      let data = this.$qs.stringify({ client_mark: "declare" });
      getmyMenu(data)
        .then((res) => {
          if (res.code == 1) {
            this.list = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      const res2 = await declareItems_lists();
      this.list2 = res2.data.lists;
      let data3 = this.$qs.stringify({ usage_type: "declareFiles" });
      const res3 = await files_lists(data3);
      this.list3 = res3.data.lists;
    },
    // 跳转
    async toList(item) {
      if (item.link_url !== "/" && item.link_url !== "") {
        if (item.link_url === "/otherDeclaration") {
          const res = await getOtherActivityDeclarationResult();
          if (
            (Array.isArray(res.data) && res.data.length === 0) ||
            res.data.information_examine == 0
          ) {
            this.$router.push({
              path: item.link_url,
            });
          } else if (
            res.data.information_examine == 1 ||
            res.data.information_examine == 9
          ) {
            this.$router.push({
              path: "/otherDeclarationReview",
              query: {
                examine_status: res.data.information_examine,
                reject_reason:
                  res.data.information_examine == 9
                    ? res.data.examine_reason
                    : "",
              },
            });
          } else if (res.data.information_examine == 2) {
            this.$router.push({
              path: "/declarationResult",
            });
          }
        } else if (item.link_url === "/paperCertList") {
          const res = await getPaperCertificateList({
            page_no: 1,
            page_size: 10,
            name: "",
            position: "",
            id_card: "",
            mobile: "",
            audit_status: "",
          });
          if (res.code != 1) {
            this.$message.error("请确认尾款状态,或联系管理员");
            return false;
          } else {
            this.$router.push({
              path: item.link_url,
            });
          }
        } else {
          this.$router.push({
            path: item.link_url,
          });
        }
      } else {
        let mark = item.mark;
        if (mark === "Declare") {
          this.menu = 2;
        } else if (mark === "Download") {
          this.menu = 3;
        } else {
          this.$message.error("菜单出错了，请联系管理员!");
          return false;
        }
      }
    },
    toPath(item) {
      localStorage.setItem("theSession", JSON.stringify(item));
      this.$router.push({
        path: "/declarationInformation",
      });
    },
    down(row) {
      window.open(row.url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.template-main {
  .template-left {
    display: flex;
    flex-wrap: wrap;
    background: #fff;
    padding: 10px 0 300px 0px;
    border-radius: 8px;
    box-sizing: border-box;
  }

  .template-right {
    flex: 1;
    // padding: 0 60px;
  }
}

.template-item {
  height: 168px;
  width: 420px;
  color: #fff;
  font-size: 20px;
  position: relative;
  margin-bottom: 30px;
  margin-right: 22px;
  // background: linear-gradient(135deg, #FEB45B 0%, #F2508C 100%, #F24F8D 100%);
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  .title {
    flex: 1;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 22px;
    color: #ffffff;
    line-height: 30px;
    margin-bottom: 10px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .sub {
    color: #fff;
    width: 100%;
    font-size: 16px;
    margin-top: 5px;
    font-weight: normal;
  }

  .t-enter {
    color: #fff;
    position: relative;
    z-index: 9;
    justify-content: space-between;
  }

  > * {
    z-index: 9;
  }

  &:hover {
    color: #fff;
  }

  // &:hover::before {
  //   background: linear-gradient(135deg, #ffa431 0%, #ef2073 100%);
  // }
}

.line_ {
  width: 100%;
  height: 5px;
  background: #f3f3f3;
  margin: 20px 0;
}

.session_template-item {
  color: #fff;
  font-size: 20px;
  position: relative;
  margin-bottom: 30px;
  margin-right: 22px;
  width: 470px;
  height: 72px;
  padding: 15px;
  background: linear-gradient(90deg, #ff3489 0%, #ffae76 100%);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: end;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  .session_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .session_go_in {
    width: 61px;
    height: 28px;
    line-height: 28px;
    background: #ffffff;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #000000;
    text-align: center;
    font-style: normal;
  }
}

@media only screen and (max-width: 1280px) {
  .template-main .template-left {
    width: 100% !important;
    padding: 30px 0 70px 20px;
  }
}

@media only screen and (max-width: 767px) {
  .title {
    font-size: 16px !important;
  }
  .template-item .sub[data-v-2feb20eb] {
    font-size: 12px !important;
  }
  .content {
    // padding: initial !important;
    margin: initial !important;
  }
  .t-enter {
    font-size: 12px !important;
  }
  .el-button {
    font-size: 15px !important;
  }
  .template-left {
    width: 100% !important;
    padding: 30px 0 70px 0;
  }
  .t_item {
    width: 94%;
  }
  .template-item {
    width: 100% !important;
  }
  .template-right {
    padding: initial !important;
  }
  .template-main {
    margin-top: 10px;
  }
  .rich-text {
    padding: initial !important;
    height: initial !important;
  }
}

.prompt_text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #ffffff;
  line-height: 21px;
  text-align: left;
  font-style: normal;
}

.go_in {
  width: 72px;
  height: 34px;
  margin-top: 10px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 17px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #ffffff;
  line-height: 34px;
  text-align: center;
  font-style: normal;
}
</style>